/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Dialog_TitleInputs */

const en_directory_ads_dialog_title = /** @type {(inputs: Directory_Ads_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book the homepage banner`)
};

const zh_directory_ads_dialog_title = /** @type {(inputs: Directory_Ads_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预订首页横幅`)
};

/**
* | output |
* | --- |
* | "Book the homepage banner" |
*
* @param {Directory_Ads_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_dialog_title = /** @type {((inputs?: Directory_Ads_Dialog_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Dialog_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_dialog_title(inputs)
	return zh_directory_ads_dialog_title(inputs)
});
export { directory_ads_dialog_title as "directory.ads.dialog_title" }